module.exports = __webpack_public_path__ + "img/result5.62b42f23.png";